// extracted by mini-css-extract-plugin
export default {"container":"PujZ978EclAqxtXsyFEqNA==","label":"BVUkGilLE5qswQnOz4n0Yg== body-standard"};